var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"video",attrs:{"src":_vm.src,"autoplay":"","playsinline":"","muted":"","loop":""},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }